<template>
  <div class="flex-col-nowrap-center-center-center">
    <n-popover trigger="hover">
      <template #trigger>
        <img v-if="imageSrc.length > 0" :style="imageStyle" :src="imageSrc" />
        <ec-icon v-else name="common/image" :size="width" />
      </template>
      <div class="flex-col-nowrap-center-center-center">
        <img :style="prevewStyle" :src="previewSrc" />
        <a v-if="downloadable" :href="previewSrc" style="text-decoration: none">下载</a>
      </div>
    </n-popover>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    loading?: boolean
    src: string
    width: number
    height: number
    previewSrc: string
    previewWidth: number
    previewHeight: number
    downloadable?: boolean
  }>(),
  {
    loading: false,
    downloadable: false,
  }
)

const imageSrc = computed(() => {
  if (props.src && props.src.length > 0) {
    return props.src
  }
  return ""
})

const imageStyle = computed(() => {
  return {
    width: props.width + "px",
    height: props.height + "px",
    "object-fit": "cover",
    "border-radius": "6px",
    border: "1px solid #e0e0e0",
  } as any
})

const prevewStyle = computed(() => {
  return {
    width: props.previewWidth + "px",
    height: props.previewHeight + "px",
    "object-fit": "cover",
  } as any
})
</script>
<style scoped></style>
